import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  return authService.me().pipe(
    map(user => {
      if (!user || user.rol === 'proveedor') {
        window.location.href = environment.uniloginUrl;
        return false;
      }
      return true;
    }),
  );
};
